import React from 'react';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';

import config from '../constants/site-config';
// import { getLocalizedUrl } from '../locales/utils';

const SEO = ({ title, description, metaImage, url, locale, location }) => {
  const intl = useIntl();

  const seoTitle =
    title && title.id ? intl.formatMessage({ id: title.id }) : title || config.siteTitle;
  const seoDescription =
    description && description.id
      ? intl.formatMessage({ id: description.id })
      : description || config.siteDescription;

  const seoURL = url || config.siteUrl;
  const schemaOrgJSONLD = [
    {
      '@context': 'http://schema.org',
      '@type': 'Website',
      url: config.siteUrl,
      name: seoTitle,
      alternateName: config.siteTitleShort,
    },
    {
      '@context': 'http://schema.org',
      '@type': 'Organization',
      name: 'TEFL Iberia',
      url: 'https://tefl-iberia.com/',
      address: [
        {
          '@type': 'PostalAddress',
          streetAddress: `Carrer d’Aragó 403`,
          addressLocality: 'Barcelona',
          postalCode: '08009',
          addressCountry: 'Spain',
        },
        // {
        //   '@type': 'PostalAddress',
        //   streetAddress: 'Calle Ardilla 10',
        //   addressLocality: 'Seville',
        //   postalCode: '41010',
        //   addressCountry: 'Spain',
        // },
      ],
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '4.9',
        reviewCount: '135',
      },
    },
  ];

  return (
    <Helmet htmlAttributes={{ lang: locale }}>
      <title>{seoTitle}</title>
      <meta name="title" content={seoTitle} />
      <meta name="description" content={seoDescription} />
      {/* Schema.org tags */}
      <script type="application/ld+json">{JSON.stringify(schemaOrgJSONLD)}</script>
      {/* OpenGraph tags */}
      <meta property="og:title" content={seoTitle} />
      <meta property="og:description" content={seoDescription} />
      <meta property="og:type" content={'website'} />
      {/* <meta property="og:url" content={seoURL} /> */}
      <meta property="og:locale" content={locale} />
      <meta property="og:site_name" content={config.siteTitleShort} />
      {metaImage && <meta property="og:image" content={metaImage.replace('https', 'http')} />}
      {metaImage && <meta property="og:image:secure_url" content={metaImage} />}
      <meta property="og:image:width" content="512" />
      <meta property="og:image:height" content="512" />
      <meta name="og:email" content={config.userEmail} />
      {/* Twitter Card tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seoTitle} />
      <meta name="twitter:description" content={seoDescription} />
      <meta name="twitter:site" content={config.userTwitter || config.siteUrl} />
      {/* <meta name="twitter:image" content={seoImage} /> */}
      <meta name="twitter:creator" content={config.userTwitter || config.siteUrl} />
      <meta name="twitter:domain" content="www.tefl-iberia.com" />
      {/* <meta name="twitter:url" content={seoURL} /> */}

      {/* <link rel="alternate" hreflang="es" href={config.siteUrl + getLocalizedUrl('es', location)} /> */}
      {/* <link rel="alternate" hreflang="en" href={config.siteUrl + getLocalizedUrl('en', location)} /> */}
      {/* <link
        rel="alternate"
        hreflang="x-default"
        href={config.siteUrl + getLocalizedUrl('en', location)}
      /> */}

      {/* <link rel="dns-prefetch" href="https://fonts.gstatic.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin="anonymous" /> */}
      {/* <!-- Hotjar Tracking Code for www.tefl-iberia.com --> */}
      <script>
        {`(function(h,o,t,j,a,r){
              h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
              h._hjSettings={hjid:2115294,hjsv:6};
              a=o.getElementsByTagName('head')[0];
              r=o.createElement('script');r.async=1;
              r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
              a.appendChild(r);
          })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`}
      </script>
      {/* <!-- Facebook Pixel Code --> */}
      <meta name="facebook-domain-verification" content="7dgbxitwc2e5jw9goe17a2mhn2aroq" />
      <script>
        {`!function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window,document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '204476948357037'); 
          fbq('track', 'PageView');`}
      </script>
      <noscript>
        {`<img
          height="1"
          width="1"
          src="https://www.facebook.com/tr?id=204476948357037&ev=PageView&noscript=1"
        />`}
      </noscript>
      {/* <!-- End Facebook Pixel Code --> */}
    </Helmet>
  );
};

export default SEO;
